// Código que la venta le regala al cliente para su próxima compra: grande, copiable y con su vigencia.
import { useState } from 'react';
import { Check, Copy, Ticket } from 'lucide-react';

export interface EarnedCode {
    code: string;
    /** «$300 de descuento en tu próxima compra». */
    benefit: string;
    /** Vigencia ya formateada; ausente si no la trae. */
    validUntil?: string;
}

export function EarnedCodeCard({ code, benefit, validUntil }: EarnedCode) {
    const [copied, setCopied] = useState(false);
    const copy = (): void => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- falta en contextos no seguros
        if (!navigator.clipboard) return;
        void navigator.clipboard.writeText(code).then(() => {
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 1500);
        });
    };
    const Icon = copied ? Check : Copy;
    return (
        <div
            data-testid="closing-earned-code"
            className="flex items-center gap-3 rounded-[10px] border border-success-soft-border bg-success-soft/50 px-3 py-2.5"
        >
            <Ticket className="size-5 flex-none text-success" aria-hidden />
            <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5">
                    <span className="truncate font-mono text-[18px] font-bold tracking-[0.04em]">
                        {code}
                    </span>
                    <button
                        type="button"
                        aria-label={`Copiar código ${code}`}
                        title="Copiar código"
                        onClick={copy}
                        className="inline-flex flex-none items-center rounded p-1 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    >
                        <Icon className="size-3.5" aria-hidden />
                    </button>
                </div>
                <div className="text-[12px] text-success">{benefit}</div>
                {validUntil && (
                    <div className="text-[11px] text-muted-foreground">Vence el {validUntil}</div>
                )}
            </div>
        </div>
    );
}
